module.exports = __webpack_public_path__ + "media/images/vp/icon.star.gray-05a73cf6c200bd8e3d560e956dc9f513.svg";